import { socialStatusesData } from "../../../../constants/PatientFormConstants";
import { FormField } from "../../../FormEngine/types";

export const socialStatusesSchema: FormField[] = [
  {
    type: "multi-select-response",
    name: "socialStatuses",
    title: "Social Statuses",
    description: "Please select any of the following that apply to you",
    options: socialStatusesData.map((item) => ({
      value: item.value,
      label: item.description,
    })),
    schema: [
      {
        type: "input",
        name: "description",
        label: "Description",
      },
    ],
  },
];
/**
 * Social History form schema
 *
 * This schema defines the fields for the Social History form
 * using the FormEngine component.
 */
export const socialHistorySchema: FormField[] = [
  {
    type: "select",
    name: "maritalStatus",
    title: "Marital Status",
    label: "Marital Status",
    description: "Please select your marital status",
    fieldProps: {
      options: ["Married", "Single", "Widowed", "Divorced", "Other"].map((option) => ({
        label: option,
        value: option,
      })),
    },
  },
  ...socialStatusesSchema,
];

export default socialHistorySchema;
